import { render } from "./UTCClock.vue?vue&type=template&id=17db693c&scoped=true"
import script from "./UTCClock.vue?vue&type=script&lang=js"
export * from "./UTCClock.vue?vue&type=script&lang=js"

import "./UTCClock.vue?vue&type=style&index=0&id=17db693c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17db693c"]])

export default __exports__